import { useMemo, useState } from 'react';

export interface UseSlideArgs {
  count: number;
  length: number;
  initialIndex?: number;
}

export function useSlide(args: UseSlideArgs) {
  const { count, length, initialIndex = 0 } = args;
  const [index, setIndex] = useState(initialIndex);

  return useMemo(() => {
    const preDisabled = index <= 0;
    const nextDisabled = index + count >= length;

    const pre = () => {
      if (preDisabled) return;
      const next = index - count;
      setIndex(next >= 0 ? next : 0);
    };

    const next = () => {
      if (nextDisabled) return;
      const max = length - count;
      const nextIndex = index + count;
      setIndex(nextIndex <= max ? nextIndex : max);
    };

    return {
      index,
      preDisabled,
      nextDisabled,
      pre,
      next,
      setIndex,
    };
  }, [count, length, index]);
}
